import MutateExhibitType from "./MutateExhibitType";

export default MutateExhibitType